export default function Footer() {
  return (
    <footer className="bg-gray-900 mx-10 mb-10 rounded-3xl relative overflow-hidden">
      <div className="absolute inset-0 opacity-40 pointer-events-none">
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 text-gray-800 text-9xl font-bold whitespace-nowrap">
          NOLIOT
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16 mb-12">
          <div>
            <h3 className="text-4xl font-bold text-white mb-8">NOLIOT d. o. o.</h3>
            <p className="text-lg text-gray-400 font-light mb-6">iOS Excellence</p>
            <p className="text-sm text-gray-400 leading-relaxed" style={{ lineHeight: '1.6' }}>
              Modern applications for enhanced mobile experience
            </p>
          </div>

          <div>
            <h4 className="text-base font-medium text-white uppercase tracking-wider mb-7">Company</h4>
            <ul className="space-y-4">
              <li className="text-sm text-gray-400">iOS Development</li>
              <li className="text-sm text-gray-400">VPN Solutions</li>
              <li className="text-sm text-gray-400">Cleaner Apps</li>
              <li className="text-sm text-gray-400">Security Focus</li>
              <li className="text-sm text-gray-400">User Experience</li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-medium text-white uppercase tracking-wider mb-7">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-gray-500 text-lg mt-0.5"></i>
                <div>
                  <p className="text-xs text-gray-500 mb-1">Address</p>
                  <p className="text-sm text-gray-400">Nenadici 49</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-building-line text-gray-500 text-lg mt-0.5"></i>
                <div>
                  <p className="text-xs text-gray-500 mb-1">City</p>
                  <p className="text-sm text-gray-400">Nenadici</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-gray-500 text-lg mt-0.5"></i>
                <div>
                  <p className="text-xs text-gray-500 mb-1">Zip</p>
                  <p className="text-sm text-gray-400">51511</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-flag-line text-gray-500 text-lg mt-0.5"></i>
                <div>
                  <p className="text-xs text-gray-500 mb-1">Country</p>
                  <p className="text-sm text-gray-400">Croatia</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-base font-medium text-white uppercase tracking-wider mb-7">Get in Touch</h4>
            <div className="space-y-5">
              <div>
                <p className="text-xs text-gray-500 mb-1">Email</p>
                <p className="text-sm text-gray-400">info@noliotdoo.com</p>
              </div>
              <div>
                <p className="text-xs text-gray-500 mb-1">Number</p>
                <p className="text-sm text-gray-400">+1 3134745923</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © 2025 NOLIOT d. o. o. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-500 hover:text-gray-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
